// extracted by mini-css-extract-plugin
module.exports = {"styledRow":"styles_styledRow__3E_u4","styledRow__header":"styles_styledRow__header__1FNQJ","styledRow__footer":"styles_styledRow__footer__1gmze"};